import styled from "styled-components";
import { LoctoolMessage } from "@bigfish/react-loctool";

export const GReCaptchaInfo = () => {
    return (
        <ReCaptchaInfo>
            <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
                <LoctoolMessage id="common.reCaptcha" />
            </a>
        </ReCaptchaInfo>
    );
};

const ReCaptchaInfo = styled.p`
    font-size: 10px;
    font-weight: 400;
    text-align: center;
    line-height: 18px;
`;
